import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { trackEvent } from '@fs/zion-analytics'
import { useShowTemple } from '@fs/zion-permissions'
import { shape, bool } from 'prop-types'
import { TransitioningDialogOverlay, useOverlay } from '@fs/zion-ui'
import { Route } from '@fs/zion-router'
import CustomCreateGroupOverlay from '../CreateGroupOverlay/CustomCreateGroupOverlay'

import getInvitationsSections, { YOUR_STORIES_PATH } from '../../helpers/invitationsections'
import SimpleTutorialPage from './SimpleTutorialPage'

import InviteFamilyMembers from './InviteFamilyMembers'

const INVITE_FAMILY_MEMBERS_PATH = '/invite-family-members'

export default function CreateFamilyGroupPrompt({ overlay, loadFamilyGroup, onOverlayClose }) {
  const { t } = useTranslation()
  const createFamilyGroupOverlay = useOverlay()

  const [showTemple] = useShowTemple()

  useEffect(() => {
    if (!createFamilyGroupOverlay.isOpen && createFamilyGroupOverlay?.transitioning && !overlay?.transitioning) {
      overlay.close()
      loadFamilyGroup()
    }
  }, [overlay, createFamilyGroupOverlay, loadFamilyGroup])

  useEffect(() => {
    if (!overlay.isOpen && overlay?.transitioning) {
      onOverlayClose()
    }
  }, [onOverlayClose, overlay?.isOpen, overlay?.transitioning])

  useEffect(() => {
    if (overlay?.isOpen && !overlay?.transitioning) {
      trackEvent({ event_name: 'CreateFamilyGroup:SHOW_FAMILY_GROUP_PROMPT:SHOW' })
    }
  }, [overlay?.isOpen, overlay?.transitioning])
  const invitationsSections = getInvitationsSections(showTemple)

  return (
    <div>
      <TransitioningDialogOverlay {...overlay} initialLocation={YOUR_STORIES_PATH} title="">
        {invitationsSections.map((slide) => {
          slide.title = t(slide?.title)
          slide.description = t(slide.description)
          return (
            <Route key={slide.title} exact path={slide.path} title={t(slide.title)}>
              <SimpleTutorialPage slide={slide} />
            </Route>
          )
        })}
        <Route exact path={INVITE_FAMILY_MEMBERS_PATH} title={t('group-overlay.heading.create-group')}>
          <InviteFamilyMembers overlay={overlay} createFamilyGroupOverlay={createFamilyGroupOverlay} />
        </Route>
      </TransitioningDialogOverlay>
      <CustomCreateGroupOverlay overlay={createFamilyGroupOverlay} />
    </div>
  )
}

CreateFamilyGroupPrompt.propTypes = {
  overlay: shape({ isOpen: bool }),
}
